module.exports = __webpack_public_path__ + "img/santa.a5d861df.jpg";